var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[_c('label',{staticClass:"control-label"},[_vm._t("label")],2),(_vm.icon)?_c('FontAwesomeIcon',{staticClass:"icon",attrs:{"icon":_vm.icon}}):_vm._e(),_c('div',{staticClass:"value"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }